import script from "./AboutComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutComp.vue?vue&type=script&setup=true&lang=ts"

import "./AboutComp.vue?vue&type=style&index=0&id=975d8df4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-975d8df4"]])

export default __exports__